import { useEffect, useCallback, useState } from 'react';

const CHAT_WIDGET_IDS = [
  'Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window',
  'livechat-basetag',
  'starting_chat',
];

// Dummy chat widget/button is there to initiate the chat, when clicked it the real chat widget
// will be loaded/shown

export function useCloseChatWidget() {
  const [isChatClosed, setIsChatClosed] = useState<boolean>(() => {
    if (typeof sessionStorage !== 'undefined') {
      return sessionStorage.getItem('chat_widget_closed') === 'true';
    }
    return false;
  });
  const [isChatWidgetAvailable, setIsChatWidgetAvailable] = useState<boolean>(false);
  const [isDummyChatWidgetVisible, setIsDummyChatWidgetVisible] = useState<boolean>(false);
  // based on this value `isChatWidgetClosed` the close button will be shown or hidden
  // the close button will be not shown if neither the chat widget nor the dummy chat widget is visible
  // or the user has decided to close the chat for a session
  const isChatWidgetClosed = (!isChatWidgetAvailable && !isDummyChatWidgetVisible) || isChatClosed;

  const closeChatWidget = useCallback(() => {
    sessionStorage.setItem('chat_widget_closed', 'true');
    setIsChatClosed(true);
    CHAT_WIDGET_IDS.forEach((id) => {
      const chatElement = document.getElementById(id);
      if (chatElement) {
        chatElement.style.display = 'none';
      }
    });
  }, []);

  useEffect(() => {
    const dummyChatId = 'starting_chat';

    const handleOnMinimize = () => {
      setIsChatWidgetAvailable(true);
    };

    const handleOnMaximize = () => {
      const dummyChatWidgetElement = document.getElementById(dummyChatId);
      if (dummyChatWidgetElement) {
        dummyChatWidgetElement.style.display = 'none';
      }
    };

    const hideDummyChatWidget = () => {
      setIsDummyChatWidgetVisible(false);
    };

    let dummyChatWidgetElement: HTMLElement | null = null;
    const mutationCallback = () => {
      dummyChatWidgetElement = document.getElementById(dummyChatId);
      if (dummyChatWidgetElement) {
        dummyChatWidgetElement.addEventListener('click', hideDummyChatWidget);
        if (isChatClosed) {
          dummyChatWidgetElement.style.display = 'none';
        }
      }
      setIsDummyChatWidgetVisible(
        Boolean(dummyChatWidgetElement && dummyChatWidgetElement.style.display !== 'none'),
      );
      window.addEventListener('lcw:onMinimize', handleOnMinimize);
      window.addEventListener('lcw:onMaximize', handleOnMaximize);
    };

    const observer = new MutationObserver(mutationCallback);
    observer.observe(document.body, {
      childList: true,
      attributes: true,
      attributeFilter: ['style'],
    });

    return () => {
      window.removeEventListener('lcw:onMinimize', handleOnMinimize);
      dummyChatWidgetElement?.removeEventListener('click', hideDummyChatWidget);
      observer.disconnect();
    };
  }, [isChatClosed]);

  return {
    closeChatWidget,
    isChatWidgetClosed,
  };
}
